/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgWarning56(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={56}
      height={56}
      fill='none'
      viewBox='0 0 56 56'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M24.908 14.73a.75.75 0 01.75-.75h4.684a.75.75 0 01.75.75V29.56c0 .08-.013.161-.039.238l-.78 2.341a.75.75 0 01-.712.513H26.44a.75.75 0 01-.712-.513l-.78-2.341a.75.75 0 01-.039-.238V14.73zm1.5.75v13.96l.571 1.713h2.042l.57-1.713V15.48h-3.183zM28 35.837a3.092 3.092 0 100 6.184 3.092 3.092 0 000-6.184zm-1.592 3.092a1.592 1.592 0 113.184 0 1.592 1.592 0 01-3.184 0z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M27.47 2.72a.75.75 0 011.06 0L53.28 27.47a.75.75 0 010 1.06L28.53 53.28a.75.75 0 01-1.06 0L2.72 28.53a.75.75 0 010-1.06L27.47 2.72zM28 4.313L4.312 28 28 51.688 51.688 28 28 4.312z'
      />
    </svg>
  );
}

export default SvgWarning56;
